import { RouteRecordRaw } from "vue-router";
const routes: RouteRecordRaw[] = [
  {
    path: "clueEntry",
    name: "clueEntry",
    component: () => import("@/views/clue-entry/index.vue")
  }
];
export default routes;
